import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import UploadIcon from '@material-ui/icons/CloudUpload';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    textAlign: 'center'
  },
  rootNormal: {
    minHeight: 200
  },
  rootLarge: {
    minHeight: 300
  },
  rootSmall: {
    minHeight: 75
  },
  rootXsmall: {
    minHeight: 50
  },
  text: {
    padding: theme.spacing(2),
    userSelect: 'none'
  }
}));

const ImageUploadPlaceholder = ({ size }) => {
  const classes = useStyles();
  const location = useLocation();
  const rootClasses = cx(
    classes.root,
    { [classes.rootNormal]: size === 'normal' },
    { [classes.rootLarge]: size === 'large' },
    { [classes.rootSmall]: size === 'small' },
    { [classes.rootXsmall]: size === 'xsmall' }
  );
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      className={rootClasses}
    >
      <UploadIcon fontSize="large" color="secondary" />
      {location.pathname !== '/marketSettings' && (
        <Typography variant="subtitle2" classes={{ root: classes.text }}>
          Drag and drop image to this area
        </Typography>
      )}
    </Box>
  );
};

ImageUploadPlaceholder.propTypes = {
  size: PropTypes.oneOf(['normal', 'large'])
};

export default ImageUploadPlaceholder;
